import { render } from "./sliderThree.vue?vue&type=template&id=53fb54e8&scoped=true"
import script from "./sliderThree.vue?vue&type=script&lang=js"
export * from "./sliderThree.vue?vue&type=script&lang=js"

import "./sliderThree.vue?vue&type=style&index=0&id=53fb54e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53fb54e8"]])

export default __exports__